import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { Location } from '@freelancer/location';
import { IconColor } from '@freelancer/ui/icon';
import { TextSize } from '@freelancer/ui/text';
import { ViewHeaderTemplate } from '@freelancer/view-header-template';
import { map } from 'rxjs/operators';

enum ChildNavLink {
  MESSAGES = '/messages',
  UPDATES = '/navigation/updates',
}

@Component({
  selector: 'app-navigation-child',
  template: `
    <ng-container *ngIf="!loading">
      <ng-container
        *ngIf="template; else defaultView"
        [ngTemplateOutlet]="template"
      ></ng-container>
      <ng-template #defaultView>
        <fl-view-header [showBackButton]="showBackButton">
          <fl-bit class="NavigationChild" flTrackingSection="NavigationChild">
            <fl-text class="NavigationChild-title" [size]="TextSize.MID">
              <!-- TODO: set a default title? -->
            </fl-text>

            <fl-bit class="NavigationChild-actions">
              <fl-button
                class="NavigationChild-action"
                flTrackingLabel="Updates"
                [ngClass]="{
                  IsActive: currentUrl === ChildNavLink.UPDATES
                }"
                [link]="ChildNavLink.UPDATES"
              >
                <fl-icon
                  [color]="IconColor.INHERIT"
                  [name]="'ui-bell-outline-v2'"
                ></fl-icon>
              </fl-button>

              <fl-button
                class="NavigationChild-action"
                flTrackingLabel="Messages"
                [ngClass]="{
                  IsActive: currentUrl === ChildNavLink.MESSAGES
                }"
                [link]="ChildNavLink.MESSAGES"
              >
                <fl-icon
                  [color]="IconColor.INHERIT"
                  [name]="'ui-chat-square-outline'"
                ></fl-icon>
              </fl-button>
            </fl-bit>
          </fl-bit>
        </fl-view-header>
      </ng-template>
    </ng-container>
  `,
  styleUrls: ['./navigation-child.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationChildComponent implements OnInit {
  ChildNavLink = ChildNavLink;
  IconColor = IconColor;
  TextSize = TextSize;

  currentUrl: string;
  template?: TemplateRef<any>;
  loading: boolean;

  @Input() showBackButton = true;

  constructor(
    private viewHeaderTemplate: ViewHeaderTemplate,
    private changeDetectorRef: ChangeDetectorRef,
    private location: Location,
  ) {}

  ngOnInit() {
    // using `| async` causes ChangedAfterItHasBeenChecked errors
    // we do a manual subscription to get around this instead
    this.viewHeaderTemplate.templateChanges().subscribe(newTemplate => {
      this.template = newTemplate;
      this.changeDetectorRef.detectChanges();
    });

    this.location
      .valueChanges()
      .pipe(map(location => location.pathname))
      .subscribe(pathname => {
        this.currentUrl = pathname;
        this.changeDetectorRef.detectChanges();
      });
  }
}
